/**
 * Created by catch on 17-02-2022.
 */

import { create } from 'zustand';

const useCelebrateDialogStore = create((set) => ({
  open: false,
  template: null,
  post: null,
  stepNum: 0,
  setOpen: (isOpen, post = null) =>
    set(() => {
      const newState = { open: isOpen, post: post };

      if (!isOpen) {
        newState.template = null;
        newState.stepNum = 0;
      } else if (post) {
        newState.stepNum = 1;
      }
      return newState;
    }),
  setSelectedTemplate: (template) => set(() => ({ template, stepNum: 1 })),
  setStepNum: (step) => set(() => ({ stepNum: step })),
}));

export default useCelebrateDialogStore;
